import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

currentShippingAddressStyles.useBillingAddress = {
    button: {
        css: css`
            margin-top: 20px;
            border-radius: 25px;
            border: 1px solid ${getColor("warning")};
            background-color: ${getColor("warning")};
            > span {
                color: ${getColor("info.contrast")} !important;
                font-family: ${TYPOGRAPHY.fontFamily.base};
            }
            &:hover {
                border: 1px solid ${getColor("warning.contrast")};
                background-color: ${getColor("warning.contrast")};
            }
        `,
    },
};

currentShippingAddressStyles.editLink = {
    css: css`
        > span {
            color: ${getColor("primary")} !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smallest};
                    `,
                    null,
                ])}
        }
    `,
};

currentShippingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        > address {
            font-size: ${TYPOGRAPHY.size.smaller};
        }
    `,
};
